"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var componentStyle = {
    base: {
        width: 296,
    },
};
var description = 'You can have a nice image on top of Card by using the ' +
    '<code class="inline">image</code> property.';
var code = "import React from 'react';\nimport { Card } from 'jsc-react-ui';\n\nconst style = {\n  width: 296,\n};\n\nconst CardExample = () => (\n  <Card\n    style={style}\n    title=\"Restaurant\"\n    image=\"http://proural.info.opt-images.1c-bitrix-cdn.ru/upload/iblock/66c/66c21eb3acb6b59e85bb022d330f38a6.jpg?1497597442216529\"\n  >\n    Sed tempus, odio nec laoreet pulvinar, erat elit tristique dolor,\n    ut sollicitudin ex nunc vel eros. Sed magna erat, condimentum.\n  </Card>\n);";
exports.ImageExampleCard = function () { return (React.createElement(common_1.Example, { title: "Image", description: description, code: code },
    React.createElement(components_1.Card, { style: componentStyle.base, title: "Restaurant", image: "http://proural.info.opt-images.1c-bitrix-cdn.ru/upload/iblock/66c/66c21eb3acb6b59e85bb022d330f38a6.jpg?1497597442216529" }, "Sed tempus, odio nec laoreet pulvinar, erat elit tristique dolor, ut sollicitudin ex nunc vel eros. Sed magna erat, condimentum."))); };
exports.ImageExampleCard.displayName = 'ImageExampleCard';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentCardPage/ImageExampleCard.tsx
// module id = 644
// module chunks = 0